'use strict';

module.exports = cell;

var all = require('../all');

function cell(h, node) {
  return h(node, 'tableCell', all(h, node));
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-mdast/handlers/table-cell.js
// module id = 1021
// module chunks = 0